import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SHOW_HEADER_LOGIN = 'header/SHOW_HEADER_LOGIN';
export const showHeaderLogin = createAction(SHOW_HEADER_LOGIN);
